import { tw } from 'utils/classnames'
import { useTranslations } from 'next-intl'
import { CloseIcon } from 'primitives/icons/close'

import { BackIcon } from '@web/components/icons/back'

interface NavigationProps {
  page: number
  hasMore: boolean
  className?: string
  onClose: () => void
  setPage: React.Dispatch<React.SetStateAction<number>>
}

export function Navigation({ page, hasMore, className, onClose, setPage }: NavigationProps) {
  const t = useTranslations('prod.product_description_page.suggestions')
  const onNext = () => setPage(prev => Math.min(prev + 1))
  const onPrevious = () => setPage(prev => Math.max(prev - 1, 1))

  return (
    <div className={tw('flex min-h-12 justify-between', className)}>
      <h4 className={tw('text-14 pl-2 font-bold', 'min-[575px]:text-16')}>{t('title')}</h4>
      <div className="text-cf-dreamy-cloud-1000 flex flex-row gap-4">
        <button
          disabled={page === 1}
          onClick={onPrevious}
          className={tw(
            'hidden transition-transform duration-300 hover:scale-110 disabled:opacity-50 disabled:hover:scale-100',
            'min-[575px]:block',
          )}
        >
          <BackIcon />
        </button>
        <button
          disabled={!hasMore}
          onClick={onNext}
          className={tw(
            'hidden transition-transform duration-300 hover:scale-110 disabled:opacity-50 disabled:hover:scale-100',
            'min-[575px]:block',
          )}
        >
          <BackIcon className="-scale-x-100" />
        </button>
        <button
          onClick={onNext}
          disabled={!hasMore}
          className={tw(
            'bg-cf-lavender rounded-2 text-12 text-cf-violet hover:bg-cf-white hidden whitespace-nowrap px-4 py-2 font-medium',
            'disabled:hover:bg-cf-lavender disabled:opacity-50 min-[575px]:block',
          )}
        >
          {t('show_more')}
        </button>
        <button className="ml-2 mr-2 hover:scale-110" onClick={onClose}>
          <CloseIcon className="size-5" />
        </button>
      </div>
    </div>
  )
}
